const documentEditorPanelStyles = {
  editor: {
    minHeight: "65vh",
  },
  previewBackground: {
    height: "70vh",
    overflow: "hidden",
    backgroundColor: "grey.600",
    padding: "1rem",
  },
  previewEmbedContainer: {
    height: "100%",
  },
};

export default documentEditorPanelStyles;
